import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '@mkp/user/models';
import { VacancyFlow } from '@mkp/vacancy/models';
import { Vacancy } from '@mkp/vacancy/models';
import { ProductCode } from '@mkp/shared/models';
import { CartDto } from '@mkp/publication/models';

export const productSummaryPageActions = createActionGroup({
  source: 'Product Summary Page',
  events: {
    Enter: props<{ productCode: ProductCode | undefined }>(),
    Checkout: props<{
      vacancyId: string;
      overrideUser: User | null;
      sendConfirmationEmail: boolean;
      walletId?: string;
      start?: string;
    }>(),
    'Apply Coupon': props<{ coupon: string; walletId: string; overrideUser: User | null }>(),
    'Remove Coupon': props<{ walletId: string; overrideUser: User | null }>(),
    'Change Product': props<{ flow: VacancyFlow; vacancyId: string }>(),
    'Unverified Checkout': props<{
      vacancy: Vacancy;
      productName: string;
      productQuantity: number;
      cart: CartDto;
      start?: string;
    }>(),
    'Reset Platform Group Post Checkout': emptyProps(),
  },
});
